import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

// TODO: `components` should not import from `pages`.
import { ChevronDownIcon } from '@app/pages/Prototype/icons';

import { designSystemTokens } from '../DesignSystem';

export const Outer = styled.div<{ isOpen: boolean; $simplified?: boolean }>`
    && {
        background-color: transparent;
        box-sizing: border-box;
        position: relative;
        z-index: 2;

        ${({ $simplified }) =>
            $simplified
                ? css`
                      flex-shrink: 0;
                  `
                : css`
                      height: 40px;
                      margin-bottom: 5px;
                      transition: width 0.2s ease;
                      width: 149px;
                      width: 100%;

                      @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
                          width: 149px;
                          height: 50px;
                          margin-bottom: 0;
                      }
                  `}

        ${({ isOpen }) =>
            isOpen &&
            css`
                @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
                    width: 243px;
                }
            `}
    }
`;

export const Wrapper = styled.div<{ isOpen: boolean; $simplified?: boolean }>`
    && {
        align-items: center;
        cursor: pointer;
        display: flex;
        height: 100%;
        position: relative;
        user-select: none;

        ${({ $simplified }) =>
            $simplified
                ? css`
                      gap: 8px;
                      justify-content: flex-start;
                  `
                : css`
                      background: #222030;
                      border-radius: 100px;
                      padding: 11px 20px;
                      justify-content: space-between;
                      width: 100%;
                      transition: border 0.2s ease;

                      @-moz-document url-prefix() {
                          background: #222030; // Force color on FireFox, backdrop-filter isnt working properly
                      }
                  `}
    }
`;

export const MainText = styled.p<{ $simplified?: boolean }>`
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 1;
    text-align: left;
    letter-spacing: -2%;
    color: ${({ theme }) => theme.colors.white};
    white-space: nowrap;

    ${({ $simplified }) =>
        $simplified &&
        css`
            font-size: 18px;
            margin: 0;
        `}
`;

export const DropdownContent = styled(motion.ul)<{ $simplified?: boolean }>`
    border-radius: ${({ $simplified }) => ($simplified ? '8px' : '20px')};
    left: 0;
    list-style: none;
    margin: 0;
    padding: 12px 8px;
    position: absolute;
    top: 56px;

    ${({ $simplified }) =>
        $simplified
            ? css`
                  background: ${({ theme }) => theme.colors.darkBg};
              `
            : css`
                  width: 100%;
                  background: #222030;

                  @-moz-document url-prefix() {
                      background: #222030; // Force color on FireFox, backdrop-filter isnt working properly
                  }

                  @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
                      top: 66px;
                  }
              `}
`;

export const DropDownItem = styled.li<{ isActive?: boolean; isDisabled?: boolean; $simplified?: boolean }>`
    position: relative;
    cursor: pointer;
    padding: 11px 12px;
    margin-bottom: 4px;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;

    transition: background 300ms ease;
    overflow: hidden;
    width: 100%;

    &:hover {
        background: ${({ theme, $simplified }) =>
            $simplified ? theme.shades.white[20] : designSystemTokens.shades.primary.light[10]};
    }

    &:focus {
        outline: 0 solid transparent;
        background: ${({ theme, $simplified }) =>
            $simplified ? theme.shades.white[10] : designSystemTokens.shades.primary.light[20]};
    }

    ${({ isActive, theme, $simplified }) =>
        isActive &&
        css`
            background: ${$simplified ? theme.shades.white[10] : designSystemTokens.shades.primary.light[10]};
        `};

    ${({ isDisabled }) =>
        isDisabled &&
        css`
            cursor: not-allowed;
            background: transparent !important;
            p {
                opacity: 0.5;
            }
        `};
    &:last-of-type {
        margin-bottom: 0;
    }
`;

export const DropDownContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    max-width: 100%;
`;

export const DropDownText = styled.p`
    font-family: 'Alliance No.1';
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    text-align: left;
    letter-spacing: -3%;
    margin: 0;
    padding: 0;
    color: ${({ theme }) => theme.colors.white};
    width: 189px; // prevent text shift while animating menu
`;

export const DropDownDescription = styled.p`
    font-family: 'Alliance No.1';
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    text-align: left;
    letter-spacing: -1%;
    margin: 0;
    padding: 0;
    color: ${({ theme }) => theme.colors.white};
    opacity: 0.6;
    padding-right: 6px;
    overflow: hidden;
`;

export const Chevron = styled(ChevronDownIcon)<{ $isOpen: boolean }>`
    fill: transparent !important;
    width: 10px;
    transition: transform 0.2s ease;

    ${({ $isOpen }) =>
        $isOpen &&
        css`
            transform: rotate(180deg);
        `};
`;
